import wrapper from 'wrapper';
import events from '../../utils/events-emitter';
import ParallaxHeader from '../parallax-header/parallax-header';
import getSupportedImageFormat from '../../utils/getSupportedImageFormat';

const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
})(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

class AnimationToggle {
    constructor() {
        this.toggle = wrapper.select('.animation-toggle');
        this.toggleLabel = wrapper.select('.toggle__label');
        this.toggle.addEventListener('change', e => {
            events.emit('animation-toggled', e.target.checked);
        });
        events.on('animation-toggled', (checked) => this.updateAnimationStatus(checked));

        // disable animation by default is prefers-reduced-motion enabled
        // otherwise set to enabled, prevents mismatch on reload if user checked and refreshed
        const checkbox = this.toggle.querySelector('input');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
        checkbox.checked = !prefersReducedMotion;
        this.toggleLabel.textContent = checkbox.checked ? __('animation_toggle_enabled') : __('animation_toggle_disabled');

        getSupportedImageFormat()
            .then((format) => {
                let supportedImageFormat = format; // 'avif' => 'webp' => 'png'
                if (isSafari) supportedImageFormat = 'png';
                this.parallaxHeader = new ParallaxHeader(checkbox.checked, supportedImageFormat);
            });
        this.getAnimatedElements();

        this.updateAnimationStatus(checkbox.checked);
    }

    updateAnimationStatus(checked) {
        if (checked) {
            // Uncomment this if you want the images to reanimate on toggle
            // if (!this.parallaxHeader.animated) {
            //     this.parallaxHeader = new ParallaxHeader(checked);
            // }
            this.toggleLabel.textContent = __('animation_toggle_enabled');
            this.animatedEls.forEach((el) => el.classList.add('animated'));
        }
        else {
            // Uncomment this if you want the images to reanimate on toggle
            // this.parallaxHeader.animated = checked;
            this.toggleLabel.textContent = __('animation_toggle_disabled');
            this.animatedEls.forEach((el) => el.classList.remove('animated'));
        }
        if (this.parallaxHeader) this.parallaxHeader.updateAnimationStatus(checked);

        wrapper.trackUserAction('Animation button clicked', `Animation ${checked ? 'enabled' : 'disabled'}`);
        this.updateAnimatedElements(checked);
    }

    getAnimatedElements() {
        this.animatedEls = wrapper.selectAll('.animated');
        this.animatedImageEls = wrapper.selectAll('.animated-img');
        this.animatedImages = [];
        this.animatedImageEls.forEach((img) => {
            this.animatedImages.push({
                el: img,
                gif: img.src,
                fallback: img.dataset.fallback,
            });
        });

        // this.parallaxHeader = wrapper.selectAll('.parallax-header svg image[id*=group-]');
        this.hiddenSteps = wrapper.selectAll('.step.hidden');
        this.stepsToMinifyIfAnimationsDisabled = this.hiddenSteps.filter((el) => el.classList.contains('animated'));
    }

    updateAnimatedElements(animationEnabled) {
        if (!animationEnabled) return;

        this.animatedImages.forEach((img) => {
            const { el, fallback, gif } = img;
            el.src = animationEnabled ? gif : fallback;
        });

        this.stepsToMinifyIfAnimationsDisabled.forEach((step) => {
            step.classList.remove('skip-step');
            if (!animationEnabled) step.classList.add('skip-step');
        });
    }
}

export default AnimationToggle;
